var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":"box"}},[_c('Nav2'),_c('StarDemo'),_c('div',[_c('section',{staticClass:"banner",attrs:{"id":"one"}},[_c('index')],1)]),_c('Foot2')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }